/**
 * Turn a FastAPI error `detail` (string, array of validation objects, or object)
 * into a safe single string for toasts — never pass raw objects to React/Sonner.
 */
export function errorMessage(detail, fallback = 'Something went wrong') {
  if (detail === undefined || detail === null || detail === '') return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const parts = detail.map((e) => {
      if (typeof e === 'string') return e;
      const loc = Array.isArray(e?.loc) ? e.loc[e.loc.length - 1] : e?.loc;
      return `${loc || 'field'}: ${e?.msg || 'invalid value'}`;
    });
    return parts.join('; ') || fallback;
  }
  if (typeof detail === 'object') return detail.msg || detail.detail || fallback;
  return String(detail);
}

export default errorMessage;
